import { ContractNoticeRequest } from './service-models/contract-notice/ContractNoticeReqesut';
import { ContractNoticeResult } from './service-models/contract-notice/ContractNoticeResult';
import { BaseService } from './BaseService';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';
/**
 * 告知事項取得サービス
 */
export class ContractNoticeService extends BaseService {
	// サービス メソッド  -----------------------------------------------------------------------------------------------------------------------------
	/**
	 * 告知事項検索
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public searchContractNotice(viewCore: WprBaseViewCore, request: ContractNoticeRequest, resMethod: (result: ContractNoticeResult) => void): void {
		return this.doPost(viewCore, '/contract/get', request, resMethod);
	}
	// -----------------------------------------------------------------------------------------------------------------------------------------------
}